export default {
    capFirstLetter(str) {

        if (str.length === 0) {
            return str;
        }

        if (str.length === 1) {
            return str.charAt(0).toUpperCase();
        }

        return str.charAt(0).toUpperCase() + str.slice(1);
    },

    formatAsPrice(val) {
        val = parseFloat(val).toFixed(2);

        if (isNaN(val)) {
            return '';
        }

        var tmp = Math.abs(val);

        if (tmp > 999.99) {
            let priceParts = val.toString().split('.');
            switch (priceParts[0].length)
            {
            case 4:
                return priceParts[0][0]+','+priceParts[0][1]+''+priceParts[0][2]+''+priceParts[0][3]+'.'+priceParts[1];

            case 5:
                return priceParts[0][0]+''+priceParts[0][1]+','+priceParts[0][2]+''+priceParts[0][3]+''+priceParts[0][4]+'.'+priceParts[1];

            case 6:
                return priceParts[0][0]+''+priceParts[0][1]+''+priceParts[0][2]+','+priceParts[0][3]+''+priceParts[0][4]+''+priceParts[0][5]+'.'+priceParts[1];
            }
        }

        return val;
    },

    formatPhoneNumber(nr) {
        nr = nr.replace(/[^a-zA-Z0-9]/g, '');

        if (nr.length === 1 || nr.length === 2) {
            return nr;
        } else if (nr.length === 3) {
            return '('+nr;
        } else if (nr.length === 4 || nr.length === 5 || nr.length === 6) {
            return '('+nr.substr(0, 3)+') '+nr.substr(3, nr.length-1);
        } else if (nr.length === 7 || nr.length === 8 || nr.length === 9 || nr.length === 10) {
            return '('+nr.substr(0, 3)+') '+nr.substr(3, 3)+'-'+nr.substr(6, nr.length-1);
        }

        return nr;
    },
    openPDFInWindow(data, fileName) {
        var binaryString = window.atob(data);
        var binaryLen = binaryString.length;
        var bytes = new Uint8Array(binaryLen);
        for (var i = 0; i < binaryLen; i++) {
            bytes[i] = binaryString.charCodeAt(i);
        }

        var link = document.createElement('a');
        link.href = window.URL.createObjectURL(new Blob([bytes], { type: 'application/pdf' }));
        link.download = fileName;
        link.target = '_blank';
        link.click();
    },
};



// WEBPACK FOOTER //
// ./ui_src/app/utils/Utils.js